module.exports = __webpack_public_path__ + "static/media/donate.d181ec98.svg";